const lbaRange = angular.module('app.lbaRange', []);

lbaRange.controller('lbaRangeCtrl', require('./lbaRangeCtrl'));
lbaRange.directive('lbaRange', require('./lbaRangeDir'));

export default lbaRange;



// WEBPACK FOOTER //
// ./src/components/lbaRange/index.js